import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import Layout from "./hocs/Layout";
import AuthPage from "./containers/AuthPage/AuthPage";
import PrivateRoute from "./components/PrivateRoute";
import Services from "./containers/Services/Services";

import CounterPartyIssues from "./containers/CounterPartyIssues/CounterPartyIssues/CounterPartyIssues";
import CounterPartyIssueDetails from "./containers/CounterPartyIssues/CounterPartyIssues/CounterPartyIssueDetails";
import ReportedIssues from "./containers/ReportedIssues/ReportedIssues/ReportedIssues";
import ReportedIssueDetails from "./containers/ReportedIssues/ReportedIssues/ReportedIssueDetails";
import { ContactUs } from "./containers/ContactUs/ContactUs";
import Faqs from "./containers/Faqs/Faqs";
import Analytics from "./containers/Analytics/Analytics";
import Orders from "./containers/Orders/Orders";
import OrderDetails from "./containers/Orders/OrderDetails";

function App() {
  const { authData, raiseIssue, attribute } = useSelector(
    (state) => state.loginSlice
  );
  //console.log(raiseIssue);
  //console.log(attribute);

  return (
    <Routes>
      <Route path="/login" element={<AuthPage />} />
      <Route element={<PrivateRoute />}>
        <Route path="/services" element={<Services />} />
       
        <Route element={<Layout />}>
         <Route
            path="/"
            element={<Analytics/>}
          />
          {/* <Route
            path="/"
            element={
              raiseIssue ? (
                <Navigate to="/issues/seller" replace />
              ) : (
                <Navigate to="/issues/buyer" replace />
              )
            }
          /> */}
          <Route path="/orders" element={<Orders/>} />
          <Route path="/orders/:orderId" element={<OrderDetails/>} />


          <Route path="/issues/buyer" element={<CounterPartyIssues />} />
          <Route
            path="/issues/buyer/:issueId"
            element={<CounterPartyIssueDetails />}
          />
          <Route path="/issues/seller" element={<ReportedIssues />} />
          <Route
            path="/issues/seller/:issueId"
            element={<ReportedIssueDetails />}
          />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/faq" element={<Faqs />} />
        </Route>
      </Route>

      <Route
        path="*"
        element={
          <Navigate to={authData ? "/issues/buyer" : "/login"} replace />
        }
      />

      {/* <Route
        path="*"
        element={<Navigate to={authData ? "/orders" : "/login"} replace />}
      /> */}
    </Routes>
  );
}

export default App;
